export enum Common {
  PageContext = 'common.pageContext',
  PageSubContext = 'common.pageSubContext',
  Preorders = 'common.preorders',
  Reviews = 'common.reviews',
  ReviewSettings = 'common.reviewSettings',
  AllProducts = 'common.allProducts',
  AllProductsDefault = 'common.allProducts.default',
  EnvironmentContext = 'common.environmentContext',
  AssetPathFn = 'common.assetPathFn',
  AbTests = 'common.abTests',
  DeviceType = 'common.deviceType',
  IsMobile = 'common.isMobile',
  IsDesktop = 'common.isDesktop',
  IsTablet = 'common.isTablet',
  MarketingPromo = 'common.marketingPromo',
  Shopify = 'common.Shopify',
  ToViewPriceFn = 'common.toViewPriceFn',
  SkuAvailability = 'common.skuAvailability',
  SmsPhoneStatus = 'common.smsPhoneStatus',
  Products = 'common.products',
  ProductList = 'common.productList',
  CategoryFilterProducts = 'common.categoryFilterProducts',
  MobileMenuOpen = 'common.mobileMenuOpen',
  AppliedDiscountCode = 'common.appliedDiscountCode',
  Customer = 'common.customer',
  CustomerFetchingState = 'common.customerFetchingState',
  ActiveCategory = 'common.activeCategory',
  ActiveCollectionFilter = 'common.activeCollectionFilter',
  CollectionFilterState = 'common.collectionFilterState',
  CollectionSelectedVariantFamily = 'common.collectionSelectedVariantFamily',
  CollectionSelectedVariantFamilyDefault = 'common.collectionSelectedVariantFamily/default',
  CollectionHandle = 'common.collection',
  BundleCollectionSwatch = 'common.bundleCollectionSwatch',
}

export enum Selections {
  Handle = 'selections.handle',
  SubContext = 'selections.subContext',
  Preorder = 'selections.preorder',
  Size = 'selections.size',
  Color = 'selections.color',
  Variant = 'selections.variant',
  Product = 'selections.product',
  InitializeQuickView = 'selections.initializeQuickView',
  InitializeCompleteTheLook = 'selections.initializeCompleteTheLook',
  SizingToolState = 'sizingToolState',
  ModalState = 'modalState',
  CartDrawer = 'CartDrawer',
  Cart = 'Cart',
  KlaviyoResponse = 'selections.klaviyoResponse',
  Fit = 'selections.fit',
  BundleCollection = 'selections.bundleCollection',
  _Fit = 'selections._fit',
  _Handle = 'selections._handle',
  _Size = 'selections._size',
  _Color = 'selections._color',
  _Denomination = 'selections._denomination',
  _SizingToolState = '_sizingToolState',
  _ModalState = '_modalState',
  _CartDrawer = '_CartDrawer',
  _Cart = '_Cart',
  _KlaviyoResponse = '_KlaviyoResponse',
  _ConfirmedForBundleStepper = 'selections._confirmedForBundleStepper',
}
